import React from 'react'
import {NavigationDots,SocialMedia} from '../components';


const AppWrap = (Component, idName, classNames ) => function HOC()  {
  return (
    <div 
    id={idName} className={`app__container ${classNames}`} >
        <SocialMedia/>
        <div className='app__wrapper app__flex' >
            <Component/>
       

        <div className='copyright'>
        <p className='p-text'>👩 Dr Eman's Dental Care </p>
        <p className='p-text'>All rights reserved ©️</p>
        <a href='https://www.google.com/maps/dir/Bahria+Town+Safari+Villas+3,+Rawalpindi,+Islamabad,+Punjab,+Pakistan/dr+emans+dental+care/@33.5545291,73.1256169,18z/data=!3m1!4b1!4m13!4m12!1m5!1m1!1s0x38dfed03abc0299b:0x3f179dd72603e8df!2m2!1d73.1253715!2d33.5551746!1m5!1m1!1s0x38dfed4cd72457c3:0x2a3b66bfb5134a9f!2m2!1d73.1285317!2d33.5538947' 
         target='_blank'>
        <p className='p-text' >📍 7/11 mini commercial market, Phase V, Bahria Town , Rawalpindi, Pakistan
     
</p></a>
        </div>  
        
        </div>
        <NavigationDots active={idName}/>
    </div>
  )
}

export default AppWrap